import { combineReducers } from 'redux';

/**
 * This function produces a combined reducer representing the selected object.
 */
const selected = (OBJECT = undefined) => {
  if (OBJECT === undefined) {
    throw new Error('Cannot create reducer, missing arguments');
  }

  /**
   * Maintains the ID of the selected object fetch, updated on every request.
   */
  const id = (state = null, { meta, type }) => {
    switch (type) {
      case `FETCH_${OBJECT}_PENDING`:
        return meta.id;
      default:
        return state;
    }
  };

  /**
   * Current error state of fetch request, set when fetch failure occurs,
   * reset on success or when new request begins.
   */
  const error = (state = null, { payload, type }) => {
    switch (type) {
      case `FETCH_${OBJECT}_REJECTED`:
        // Rejection may come from 'cancelled' Promise, see actions
        return payload.cancelled ? state : payload;
      case `FETCH_${OBJECT}_PENDING`:
      case `FETCH_${OBJECT}_FULFILLED`:
        return null;
      default:
        return state;
    }
  };

  /**
   * Current fetching state of list, updated when request begins or ends.
   */
  const fetching = (state = false, { payload, type }) => {
    switch (type) {
      case `FETCH_${OBJECT}_PENDING`:
        return true;
      case `FETCH_${OBJECT}_FULFILLED`:
      case `FETCH_${OBJECT}_REJECTED`:
        // Rejection may come from 'cancelled' Promise, see actions
        return payload.cancelled ? state : false;
      default:
        return state;
    }
  };

  return combineReducers({
    id,
    error,
    fetching,
  });
};

export default selected;

/**
 * Selectors
 */
export const getError = state => state.error;

export const getFetching = state => state.fetching;

export const getId = state => state.id;



// WEBPACK FOOTER //
// ./app/src/state/reducers/bySelection.js